module.exports = __webpack_public_path__ + "1ac45dcf7f9c61a82c5763b19d7cbd79.svg";